import React from "react";
import ReactCountryFlag from "react-country-flag";
import { Select } from "antd";
import "./CurrencySelector.css";

import { getCountryCodeForCurrency } from "utils/utils";

export default class CurrencySelector extends React.Component {
  render() {
    return (
      <span className="currency-selector-container">
        <Select
          showSearch={window.innerWidth <= 600 ? false : true}
          size={this.props.size}
          {...this.props}
          style={{ width: "200", fontSize: 16 }}
          defaultValue={this.props.defaultValue}
          onChange={this.props.onCurrencyChanged}
          optionFilterProp="children"
            mode={this.props.mode || "default"}
            filterOption={(input, option) =>
                option.props.children[1].props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0

            }
        >
          {this.props.currencies.map((currency, idx) => {
            return (
              <Select.Option key={currency} currency={currency}>
                <ReactCountryFlag code={getCountryCodeForCurrency(currency)} />
                <span style={{marginLeft: "5px"}}>{currency}</span>
              </Select.Option>
            );
          })}
        </Select>
      </span>
    );
  }
}
